"use client";

import { ArrowLeft } from "@/components/icons/arrow";
import Link from "@/components/shared/link";
import { useRouter } from "next/navigation";

export function GoBack() {
  const router = useRouter();

  if (history.length < 3) {
    return (
      <Link
        href={"/news"}
        className="flex items-center justify-center bg-foreground p-4 transition-all duration-150 ease-in hover:bg-secondary/10"
      >
        <ArrowLeft />
      </Link>
    );
  }

  return (
    <button
      onClick={() => router.back()}
      className="flex items-center justify-center border-none bg-foreground p-4 transition-all duration-150 ease-in hover:bg-secondary/10"
    >
      <ArrowLeft />
    </button>
  );
}
